
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[...detail]",
      function () {
        return require("private-next-pages/services/[...detail].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[...detail]"])
      });
    }
  